import { render, staticRenderFns } from "./PlusBacterial.vue?vue&type=template&id=62d92adc&scoped=true"
import script from "./PlusBacterial.vue?vue&type=script&lang=js"
export * from "./PlusBacterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d92adc",
  null
  
)

export default component.exports